import mapboxgl from 'mapbox-gl';
import { supabase } from '@/integrations/supabase/client';

export const initializeMap = (container: HTMLDivElement, selectedLocation?: { lat: number; lng: number }) => {
  return new mapboxgl.Map({
    container,
    style: 'mapbox://styles/mapbox/streets-v12',
    center: selectedLocation ? [selectedLocation.lng, selectedLocation.lat] : [-74.5, 40],
    zoom: selectedLocation ? 13 : 9,
  });
};

export const setupLocationSelection = (
  map: mapboxgl.Map,
  onSelect: (lat: number, lng: number, address: string) => void
) => {
  const clickHandler = async (e: mapboxgl.MapMouseEvent) => {
    const { lng, lat } = e.lngLat;

    try {
      const { data: { MAPBOX_TOKEN } } = await supabase
        .functions.invoke('get-mapbox-token');

      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_TOKEN}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch address data');
      }

      const data = await response.json();
      const address = data.features?.[0]?.place_name || '';
      
      onSelect(lat, lng, address);
    } catch (error) {
      console.error('Error getting address:', error);
    }
  };

  map.on('click', clickHandler);

  return () => {
    map.off('click', clickHandler);
  };
};